export const ClaimsPaths = {
	Index: {
		route: "/claims",
		path: "/claims",
	},
};
